'use client';
import { useEffect, useMemo, useState } from 'react';
import style from './style.module.scss';
// ------------------组件------------------
import ProductCard from '@/components/productCard';
import SafeLink from '@/components/SafeLink';
import { useRouter } from 'next/navigation';
import SaleTips from './saleTips';

interface HappyHourPropTypes {
  moduleData: any;
  currentMills: number;
  localInfo: any;
  floorIndex: number;
}

export default function Module({ moduleData, floorIndex, localInfo }: HappyHourPropTypes) {
  const [pageConfig, setPageConfig] = useState<any>({});
  const router = useRouter();
  const [touchStartX, setTouchStartX] = useState(0);

  // @ts-ignore
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  // @ts-ignore
  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const deltaX = touchEndX - touchStartX;

    if (deltaX < -100) {
      router.push('/happy');
    }
  };
  const initConfig = (moduleData: any) => {
    const newPageConfig = {
      moreLinks: `/happy`,
      products: moduleData?.externalData?.data,
      title: moduleData?.dataBatch?.title[0],
    };

    // --------------商卡信息--------------
    newPageConfig.products?.forEach((p: any, index: number) => {
      p.type = '1';
      p.currency = localInfo?.currencyCode;
      p.languageCode = localInfo?.languageCode;
      p.originalPrice = p?.originalPriceV2;
      p.originalPriceTips = p?.originalPriceDesc;
      p.onClickProduct = () => {
        router.push(`/happy?groupId=${p.groupId}&batchId=${p.batchId}`);
      };
      p.saleTipsDom = SaleTips(p.stockLabelText);

      // --------------商卡样式--------------
      p.width = '120px';
      p.height = '168px';
      p.containerStyle = {
        flex: '0 0 auto',
      };
      p.priceStyle = {
        fontSize: '12px',
      };
      p.realPriceJDIPriceParams = {
        symbolStyle: { fontSize: '12px' },
        integerStyle: { fontSize: '16px' },
        decimalPointStyle: { fontSize: '12px' },
        decimalPlaceStyle: { fontSize: '12px' },
      };
      p.originalPriceJDIPriceParams = {
        containerStyle: {
          fontWeight: 500,
          fontSize: '12px',
        },
      };
      p.skuImgStyle = {
        width: '120px',
        height: '120px',
        borderRadius: '4px',
      };
      p.priority = floorIndex < 6 && index < 4;
    });
    setPageConfig(newPageConfig);
  };

  useEffect(() => {
    initConfig(moduleData);
  }, [moduleData, localInfo]);

  const productComponents = useMemo(() => {
    return pageConfig.products?.map((product: any) => (
      <ProductCard productData={product} key={product.skuId} />
    ));
  }, [pageConfig.products]);

  if (!pageConfig.products) return null;

  return (
    <div className={style['uk-h5-happy-hour']}>
      <SafeLink href={pageConfig.moreLinks}>
        <div className={style.bar}>
          <p className={style.title}>{pageConfig?.title?.title}</p>
          <div className={style.subTitle}>
            <p>{pageConfig?.title?.subTitle}</p>
          </div>
        </div>
      </SafeLink>

      <div className={style.products} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
        {productComponents}
      </div>
    </div>
  );
}
